import { render, staticRenderFns } from "./CheckboxInputConfig.vue?vue&type=template&id=67fc54cd&"
import script from "./CheckboxInputConfig.vue?vue&type=script&lang=js&"
export * from "./CheckboxInputConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports